import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { AppState } from '../app.service';
import { ClientService } from '../client/client.service'
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path.model';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { CohortService } from '../cohorts/cohort.service'
import { Location } from '@angular/common';
import { slideInLeftOnEnterAnimation, slideOutLeftOnLeaveAnimation, slideOutRightAnimation, slideOutRightOnLeaveAnimation } from 'angular-animations';
import { ModalController,Platform } from '@ionic/angular';
import { I18n } from '../i18n.service';
import Swiper from 'swiper';
import { CordovaService } from '../cordova.service';
import { ThemeService } from '../theme/theme.service';
import { UserService } from '../user/user.service';
import { SessionService } from '../session/session.service';
import { HomeUiService } from '../new-design/home-ui.service';
export interface Collapse {
  isCollapsable: boolean;
  isCollapsed: boolean;
}

@Component({
  selector: 'app-all-paths',
  templateUrl: './all-paths.component.html',
  styleUrls: ['./all-paths.component.scss'],
  animations:[slideOutRightAnimation({duration:500}),
  slideOutRightOnLeaveAnimation({duration:100}),
  slideOutLeftOnLeaveAnimation({duration:150}),
  slideInLeftOnEnterAnimation({duration:500}),
  slideOutRightAnimation({duration:500})
]
})
export class AllPathsComponent implements OnInit, OnDestroy {

  // @Input() 'showReplayButton': boolean // LUMBA-1312
  isMobile;
  animationState;
  client: any
  @Output() animationStateChange = new EventEmitter()
  collapse: Array<Collapse>=[];
  isExpanded: boolean[] = []
  alldata: any
  allpath: any
  swiperInitialized = true;
  inoutScreens: any = []
  clientId: any
  currentpathId: any
  user: any;
  isonboardingcompleted: any;
  isActivePath: any;
  currentPath: Path
 @ViewChild('swiperContainer') swiperContainer: any;
  @ViewChild('tabsBar') tabsBar!: ElementRef;
  tabsBarHovered = false;
  tabsBarCanScrollLeft = false;
  tabsBarCanScrollRight = false;
  private isTabBarDragging = false;
  private tabBarDragMoved = false;
  private tabBarDragStartX = 0;
  private tabBarDragScrollLeft = 0;
  swiper: Swiper;
  dayHasContent: boolean
  activeDay: number
  scheduleDays: number[]
  lengthOfSnoozed: number
  dayNumber: number
  showCloseoutWelcomeScreen: boolean
  activeCloseoutWelcomeScreen: boolean // LUMBA-1312
  scheduleDay: number
  currentDayStarted: boolean
  dayHasIncompleteMandatory: boolean
  currentDayCompleted: boolean
  showContinueButton: boolean
  showBeginButton: boolean
  showCompletedMessage: boolean
  currentDayTitle: string
  currentDaySubtext: string
  allContentCompleted: boolean
  scheduledStep: any
  showReplayButton: boolean
  showUnlockButton: boolean = false
  maxAllowedScheduleDay: number 
  cohorts: any
  selectedPathsList = []
  pathRegistration;
  enabledAttributes: any
  pathVersion: boolean
  userEmail: string
  onCordova: boolean = false // LUMBA-982
  pathGroups: any
  private pathGroupsLoaded = false;
  isLoading = true;
  isChangingPath = false;
  rowHovered: boolean[] = [];
  filteredPathsGroups: any[] = [];
  expandedPaths: { [key: string]: boolean } = {};
  selectedGroupTab: string = 'all';
  pathGroupTabs: string[] = [];
  showMobileDropdown: boolean = false;
  reviewPaths= [];
  resumePaths = []
  slidesPerView;
  showSwiperBtn = false;
  @ViewChild('textCount') textCount: ElementRef;
  @ViewChildren('cardElement') cardElement: ElementRef[];
  maxHeight: number = 80;
  swiperInstances: { [key: string]: Swiper } = {};
  dailyStepsArray;
  // textareaContentLength=0;
   //set these to false to get the height of the expended container 
  constructor(
    private apollo: Apollo,
    private clientService: ClientService,
    private homeService: HomeV5Service,
    private appState: AppState,
    private toasterService: ToasterService,
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private render: Renderer2,
    private modalController: ModalController,
    public cohortService: CohortService,
    public location: Location,
    public i18n: I18n,
    public homeUIService: HomeUiService,
    public platform: Platform,
    public cordovaService: CordovaService,
    private themeService: ThemeService,
    private homeUiService: HomeUiService,
    private userService: UserService,
    public sessionService: SessionService
  ) {
    this.onCordova = this.cordovaService.onCordova
    this.user = this.appState.get('currentUser')
    this.userEmail = this.user.email
    this.currentPath = this.appState.get('currentPath')
    const clientId = localStorage.getItem('clientId')
    this.allpath =this.appState.get("allPathsData")
    if (clientId) {
      this.clientId = clientId
    }
    
    this.setPathVersion()

    this.pathRegistration = this.appState.get('pathRegistration')
    this.scheduleDay = +this.appState.get('currentScheduleDay')
    this.activeDay = this.scheduleDay
    this.scheduledStep = this.appState.get('scheduleDayForCurrentStep')
    this.maxAllowedScheduleDay = this.appState.get('daysOfContent')
    this.dailyStepsArray = this.appState.get("DailyStepsData");  
    this.checksignupcode(this.userEmail, this.clientId, this.onCordova); 
    let isPathCompleted = this.allpath?.filter((path) => path?.id == this.currentPath?.id && path.isPathCompleted == 2)
    const activePathId = localStorage.getItem('activePathId')
    if (activePathId) {
      this.currentpathId = parseInt(activePathId, 10)
    }
    this.cohorts = this.appState.get("cohortsData")
    if(!this.cohorts) {
      this.cohortService.getCohort(Number(clientId)).subscribe(cohort => {
        this.appState.set("cohortsData",cohort.data)
        this.cohorts = cohort.data;
        this.loadPaths();
      });
    } else {
      this.loadPaths();
    }
  }

  ngOnDestroy() {
    this.swiper?.destroy(true, true);

    Object.values(this.swiperInstances).forEach(swiper => {
      swiper?.destroy(true, true);
    });

    this.swiperInstances = {};
  }
  setPathVersion(){
    this.enabledAttributes = this.appState.get("routineVersion")
    if (this.enabledAttributes.pathVersion) {
      this.pathVersion = this.enabledAttributes.pathVersion
    } else {
      this.pathVersion = false
    }
  }
  truncateText(text: string, maxLength: number) {
    if (text.length <= maxLength) return text;

    const truncated = text.slice(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');

    return truncated.slice(0, lastSpace);
  }
  closePage(){
    this.appState.set('isAllPaths', false);
    this.homeUIService.getLastModal();
    this.modalController.dismiss();
  
  }
  ngOnInit() { 
    this.isMobile = this.appState.get('isMobile');
    const savedTab = this.appState.get('allPathsSelectedTab');
    if (savedTab) { this.selectedGroupTab = savedTab; }
  }
  ngAfterViewInit() {
    //setTimeout(() => {
             //   
      //this.initSwipers();
   // }, 200);
  }

getCollapsedText() {
    if (this.selectedPathsList?.length > 0 && this.selectedPathsList?.length == this.collapse?.length) {
      return true;
    }
    if (this.appState.get("isAllPaths") && this.selectedPathsList?.length > this.collapse?.length) {
      // Pre-fill the entire collapse array at once so this condition becomes false immediately
      // on the next change detection cycle — prevents one-push-per-cycle infinite loop.
      this.collapse = Array.from(
        { length: this.selectedPathsList.length },
        () => ({ isCollapsable: false, isCollapsed: false })
      );
      setTimeout(() => {
        this.cardElement?.forEach((cardElement, index) => {
          const cardHeight = cardElement.nativeElement.offsetHeight;
          if (cardHeight > this.maxHeight) {
            this.collapse[index] = { isCollapsable: true, isCollapsed: true };
            this.render.addClass(this.textCount.nativeElement, 'reply-texts');
          } else {
            this.collapse[index] = { isCollapsable: false, isCollapsed: false };
          }
        });
      }, 100);
    }
    return true;
  }

  isDayLocked(day_number){
    if (day_number > this.scheduledStep && this.scheduledStep != this.maxAllowedScheduleDay ) {
      this.showUnlockButton = true
    } else {
      this.showUnlockButton = false
    }
  }

  // Call API only when a meaningful state change happened for the first time,
  // or when there is no cached data. Otherwise reuse the cached paths.
  private loadPaths() {
    const cachedPaths = this.appState.get('allPathsData');
    const steps = this.dailyStepsArray;
    const firstStep = steps?.[0];
    const lastStep  = steps?.[steps.length - 1];

    const firstStepStarted   = !!firstStep?.stepStatus;
    const lastStepCompleted  = lastStep?.stepStatus === 'Review';

    const needsFirstStepRefresh = firstStepStarted  && !this.appState.get('allPathsFirstStepRefreshed');
    const needsLastStepRefresh  = lastStepCompleted && !this.appState.get('allPathsLastStepRefreshed');

    if (needsFirstStepRefresh) { this.appState.set('allPathsFirstStepRefreshed', true); }
    if (needsLastStepRefresh)  { this.appState.set('allPathsLastStepRefreshed',  true); }

    if (needsFirstStepRefresh || needsLastStepRefresh || !cachedPaths) {
      this.allpaths();
    } else {
      this.processPaths(cachedPaths);
    }
  }

  async allpaths() {
    await this.clientService.getAllpaths(Number(this.clientId))
      .subscribe(
        (client:any) => {
          if (!client || !client?._data?.paths) {
            this.isLoading = false;
            return;
          }
          this.client  = client;
          this.alldata = client._data;
          this.allpath = this.alldata.paths
          this.processPaths(this.allpath);
        },
        (error) => {
          this.isLoading = false;
          this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'));
        }
      );
  }

  private processPaths(paths: any[]) {
    this.allpath = paths;
    this.appState.set('allPathCount', paths?.length);
    this.appState.set('allPathsData', paths);
    if (paths?.length > 0) {
      this.reviewPaths = paths.filter(path => path.isPathCompleted === 2);
    }
    if (!this.pathGroupsLoaded) {
      // pathGroups not ready yet; checksignupcode will render once GraphQL returns
      this.steps();
      return;
    }
    if (!this.cohorts || this.cohorts.length === 0) {
      setTimeout(() => {
        this.getCohortPaths(this.user.cohortId, this.cohorts, paths);
        this.getPathsFromCohortForWeb(this.user.cohortId, paths);
        this.isLoading = false;
      }, 700);
    } else {
      this.getCohortPaths(this.user.cohortId, this.cohorts, paths);
      this.getPathsFromCohortForWeb(this.user.cohortId, paths);
      this.isLoading = false;
    }
    this.steps();
  }

  steps() {
    for (let index = 0; index < this.allpath.length; index++) {
      const element = this.allpath[index].inoutScreens;
      this.inoutScreens.push(element)
    }
  }

  textExpand(path,collpase) {
    if(collpase){
      path.isCollapsed = false;
      path.isCollapsable = true;
    }
    else {
      path.isCollapsed = true;
      path.isCollapsable = true;
    }
    this.cdRef.detectChanges();
  }

  public changePath(active_path_id) {
    this.isChangingPath = true;
    const request = {
      'user_id': this.user.id,
      'active_path_id': active_path_id
    }
    // this.spinnerService.on();
    this.homeService.subpathchange(request, 'All Paths-Legacy').subscribe(
      (response) => {
        // this.spinnerService.off();
        this.appState.set('isAllPaths', false)
        this.appState.set("screensViewed", undefined);
        this.appState.set('stepsArray', undefined)
        this.appState.set('stepObject', undefined)
        this.appState.set('levelUpdateData', undefined)
        this.appState.set('allLevelsCompleted', undefined)
        this.appState.set('levelUpdated', undefined)
        this.appState.set('showUpdatedScreens', undefined)
        this.appState.set('levelSaveData', undefined)
        this.appState.set('weekDays', undefined)
        this.appState.set("activeCloseoutWelcomeScreen", undefined);
        localStorage.removeItem('stepCompleted')
        let data = response["data"];
        try {
          let isOnboardContentPresent = data.onboardingSurvey || data.isIntroVideo;
          if (data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted?.length > 0 && isOnboardContentPresent) {
            let value = data['isonboardingcompleted'][0];
            this.isonboardingcompleted = value["isonboardingcompleted"];
            if ((this.isonboardingcompleted === false || this.isonboardingcompleted === null) && isOnboardContentPresent) {
              this.router.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data.isIntroVideo } });                          
            } else if (this.isonboardingcompleted === true) {
              this.router.navigate(['/main']);
            }
          } else if(data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted.length===0 && isOnboardContentPresent){
              this.router.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data.isIntroVideo } });                          
          } else {
            this.homeUiService.checkSubpathStatus();
            this.router.navigate(['/main']);
          }
      }catch (error) {
          this.router.navigate(['/main']);
          //this.toasterService.error('Server or connection issue. Please check your internet connection.')
        }
        this.refresh()
      }, (error) => {
        console.log('error for path change:', error);
        // this.spinnerService.off();
        this.isChangingPath = false;
        this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
      }
    )
  }

  refresh() {
    return new Promise(resolve => {
      // here to fetch the data and rerender the contents.
      this.appState.refreshMainComponent.emit()
      setTimeout(resolve, 0)
    })
  }

  showChangePath(pathId){
    if(pathId!=this.currentpathId){
      // this.getCollapsedText()
      return true
    } 

    else false
  }

  get isLastCurrentDayCompleted(): boolean {
    
    const lastDayOfContent = this.currentPath.lastDayOfContent()
    var value = !!this.homeService.checkPrevDayCompleted(
      this.pathRegistration,
      lastDayOfContent,
      this.user,
      this.currentPath
    )
    return value
  }

  showCompletionStatus(index){
    this.scheduleDay = index
    this.isDayLocked(this.scheduleDay)
    this.scheduleDays = new Array(this.currentPath.daysOfContent)
      .fill(0)
      .map((item, index) => index + 1)
      
    this.currentDayStarted = !!localStorage.getItem(
      `Toggle:User:${this.user.id}:DayProgress:${this.currentPath.id}:${this.scheduleDay}`
    )
    this.currentDayCompleted = !!localStorage.getItem(
      `Toggle:User:${this.user.id}:DayCompleted:${this.currentPath.id}:${this.scheduleDay}`
    )
    this.allContentCompleted = this.appState.get('allContentCompleted')
    this.dayHasIncompleteMandatory = this.currentPath.checkMandatoryForDay(
      this.scheduleDay
    ) // LUMBA-1317
    this.showCloseoutWelcomeScreen = this.isLastCurrentDayCompleted

    this.currentDayTitle = this.currentPath.getHomepageTitleForDay(this.scheduleDay)
    this.currentDaySubtext = this.currentPath.getHomepageSubtextForDay(
      this.scheduleDay
    )
    this.dayHasContent = this.currentPath.checkContentForDay(this.scheduleDay)
    // Instead of maxAllowedScheduled we added scheduledStep cause maxAllowedScheduleDay is nothing but total day of content
    if (this.scheduleDay === this.scheduledStep) {
      if (this.showCloseoutWelcomeScreen) {
        if (this.scheduleDay < this.currentPath.daysOfContent) {
          // LUMBA-1435
          this.activeDay = this.currentPath.daysOfContent + 1
        } else {
          this.activeDay = this.scheduleDay + 1
        }
        this.activeCloseoutWelcomeScreen = true
      }
      this.showCompletedMessage =
        !this.dayHasIncompleteMandatory && this.dayHasContent
      this.showContinueButton =
        this.dayHasIncompleteMandatory && this.currentDayStarted // LUMBA-1339
      this.showReplayButton =
        this.dayHasContent &&
        !this.dayHasIncompleteMandatory &&
        (this.currentDayCompleted || this.currentDayStarted) // LUMBA-1339
      this.showBeginButton =
        !this.currentDayCompleted &&
        this.dayHasContent &&
        !this.currentDayStarted
    } else {
      this.showCompletedMessage = this.dayHasContent
      this.showContinueButton = false
      this.showReplayButton = this.dayHasContent
      this.showBeginButton = false
    }

    if (!this.showUnlockButton) {
      if((this.currentDayStarted && !this.showReplayButton) || this.showBeginButton){
        return 'In-progress'
      } 
      if(this.showReplayButton){
        return 'Completed'
      } 
    }
    
    if(this.showUnlockButton){
      return 'Locked'
    }

  }
  receiveState(event: any){
    setTimeout(() => {
      this.animationState = event
    }, 10);
  }
  

  getCohortPaths(cohortId: number, cohorts: any, allpaths: any) {
    this.selectedPathsList = [];
    let cohortPathList = []
    cohorts?.forEach(element => {
      if (element.id == cohortId) {
        cohortPathList = element?.paths
      }
    });
    if(this.user.adhocPaths.length > 0){
      let filteredAdhocPaths = []
      filteredAdhocPaths = this.allpath.filter(path => this.user.adhocPaths.includes(path.id))
      cohortPathList.push(...filteredAdhocPaths)
    }
    allpaths?.forEach(allpathsElement => {
      cohortPathList?.forEach(cohortElement => {
        if (allpathsElement.id == cohortElement.id) {
          this.selectedPathsList.push(allpathsElement)
        }
      });
    });
    
    if (this.selectedPathsList.length <= 0) {
      this.selectedPathsList = allpaths
    }
    let activepath =[]
    activepath= this.selectedPathsList?.filter(path => path?.id == this.currentpathId)
    if(activepath && activepath?.length>0 && this.selectedPathsList?.length>0) {
      this.selectedPathsList =[activepath[0], ... this.selectedPathsList.filter(path => path != activepath[0])];
      console.log("this.selected path list", this.selectedPathsList);
    }

  }
  checksignupcode(email, clientId, onCordova){
    const clientSubDomain = this.themeService.getSubDomain() 
     this.userService.pathGroupsByToken(localStorage.getItem('token') || '')
    .subscribe(
      result => {
        this.pathGroups = result;
        this.pathGroupsLoaded = true;
        if (this.allpath?.length > 0) {
          // REST already returned while GraphQL was in-flight; render now
          this.getCohortPaths(this.user.cohortId, this.cohorts, this.allpath);
          this.getPathsFromCohortForWeb(this.user.cohortId, this.allpath);
          this.isLoading = false;
        }
        // else: processPaths will call both once REST returns (pathGroupsLoaded is now true)
      },
      _error => {
        this.pathGroupsLoaded = true; // unblock processPaths even on GraphQL failure
        if (this.allpath?.length > 0) {
          this.getCohortPaths(this.user.cohortId, this.cohorts, this.allpath);
          this.getPathsFromCohortForWeb(this.user.cohortId, this.allpath);
        }
        this.isLoading = false;
      }
    );
  }
  getPathsFromCohortForWeb(cohortId, allpath) {
    const cohortPaths = [];
    const adhocPathsOnly = [];
    this.filteredPathsGroups = [];
    if (allpath?.length > 0) {
      this.reviewPaths = this.allpath.filter(path => path.isPathCompleted === 2);
      this.resumePaths = allpath.filter(path => path.isPathCompleted === 1 && this.showChangePath(path.id));
      console.log("resume paths", this.resumePaths);
    }  
    if (!cohortId || !this.cohorts?.find(cohort => cohort.id === cohortId)) {
      this.pathGroups?.forEach(group => {
        let matchingPaths;
        if (group?.client?.isCohort) {
          adhocPathsOnly.push(...this.user.adhocPaths);
           let matchedPaths = group.paths.filter(path => adhocPathsOnly.includes(path.id));
          if (matchedPaths?.length > 0) {
            matchingPaths= matchedPaths.map(path => ({
              ...path,
              language: allpath.find((p: any) => p.id === path.id)?.language || path.language,
              category: allpath.find((p: any) => p.id === path.id)?.isPathCompleted == 1 ? 'Resumed' : allpath.find((p: any) => p.id === path.id)?.isPathCompleted == 2 ? 'Review' : 'Normal'
            }));
          }
        }
        else {
           matchingPaths = group.paths.map(path => ({
            ...path,
            language: allpath.find((p: any) => p.id === path.id)?.language || path.language,
            category: allpath.find((p: any) => p.id === path.id)?.isPathCompleted == 1 ? 'Resumed' : allpath.find((p: any) => p.id === path.id)?.isPathCompleted == 2 ? 'Review' : 'Normal'
          }));
        }
    matchingPaths?.forEach((itemA) => {
      const matchedItem = group?.userGroups?.find((itemB) => itemB.pathId === itemA.id);
      if (matchedItem) {
        itemA.name = matchedItem.name;
      }
    });
        if (matchingPaths?.length > 0) {
          this.filteredPathsGroups.push({
            groupName: group.name,
            paths: matchingPaths
          });
        }
      });
    } else {
      const cohort = this.cohorts?.find(cohort => cohort.id === cohortId);
      if (cohort) {
        cohortPaths.push(...cohort.paths.map(path => path.id));
        cohortPaths.push(...this.user.adhocPaths);
      } 
      console.log('cohortPaths :', cohortPaths);
      this.resumePaths = this.resumePaths.filter(path => cohortPaths.includes(path.id));
      let reviewPaths = this.resumePaths.filter(path => cohortPaths.includes(path.id));
      console.log('resumePaths :', this.resumePaths);
      this.pathGroups?.forEach(group => {
        const matchingPaths = group.paths.filter(path => cohortPaths.includes(path.id));
        if (matchingPaths.length > 0) {
          const pathsWithCategory = matchingPaths.map(path => ({
            ...path,
            language: allpath.find((p: any) => p.id === path.id)?.language || path.language,
            category: allpath.find((p: any) => p.id === path.id)?.isPathCompleted == 1 ? 'Resumed' : allpath.find((p: any) => p.id === path.id)?.isPathCompleted == 2 ? 'Review' : 'Normal'
          }));
            pathsWithCategory?.forEach((itemA) => {
      const matchedItem = group?.userGroups?.find((itemB) => itemB.pathId === itemA.id);
      if (matchedItem) {
        itemA.name = matchedItem.name;
      }
    });
          this.filteredPathsGroups.push({
            groupName: group.name,
            paths: pathsWithCategory
          });
        }
      });
    }
    this.buildGroupTabs();
    setTimeout(() => {
      this.initSwipers();
    }, 10);
  }
  showSwiperButtons(val) {
    this.showSwiperBtn = val;
  }

  onTabsBarMouseEnter() {
    this.tabsBarHovered = true;
    this.updateTabsBarArrows();
  }

  onTabsBarScroll() {
    this.updateTabsBarArrows();
  }

  private updateTabsBarArrows() {
    const el = this.tabsBar?.nativeElement;
    if (!el) return;
    this.tabsBarCanScrollLeft  = el.scrollLeft > 0;
    this.tabsBarCanScrollRight = el.scrollLeft < el.scrollWidth - el.clientWidth - 1;
  }

  scrollTabsBar(dir: 'left' | 'right') {
    const el = this.tabsBar?.nativeElement;
    if (!el) return;
    el.scrollLeft += dir === 'right' ? 250 : -250;
    this.updateTabsBarArrows();
  }

  onTabBarMouseDown(e: MouseEvent) {
    const el = this.tabsBar?.nativeElement;
    if (!el) return;
    this.isTabBarDragging = true;
    this.tabBarDragMoved = false;
    this.tabBarDragStartX = e.pageX - el.offsetLeft;
    this.tabBarDragScrollLeft = el.scrollLeft;
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
  }

  onTabBarMouseMove(e: MouseEvent) {
    if (!this.isTabBarDragging) return;
    const el = this.tabsBar?.nativeElement;
    if (!el) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const delta = x - this.tabBarDragStartX;
    if (Math.abs(delta) > 4) this.tabBarDragMoved = true;
    el.scrollLeft = this.tabBarDragScrollLeft - delta * 1.5;
    this.updateTabsBarArrows();
  }

  onTabBarMouseUp() {
    if (!this.isTabBarDragging) return;
    this.isTabBarDragging = false;
    const el = this.tabsBar?.nativeElement;
    if (el) {
      el.style.cursor = 'grab';
      el.style.userSelect = '';
      if (this.tabBarDragMoved) {
        const suppress = (ev: Event) => { ev.stopPropagation(); el.removeEventListener('click', suppress, true); };
        el.addEventListener('click', suppress, true);
      }
    }
    this.tabBarDragMoved = false;
  }
  
  setRowHovered(index: number | string, hovered: boolean): void {
    this.rowHovered[index] = hovered;
  }
  
  initSwipers(): void {
    if (this.platform.is('desktop')) {
      this.slidesPerView = 3;
    }else if (this.platform.is('tablet')) {
      this.slidesPerView = 2;
    } 
    else {
      this.slidesPerView = 1.15;
   }
     if (this.swiperContainer?.nativeElement) {

         this.swiper = new Swiper(this.swiperContainer.nativeElement, {
          slidesPerView: this.slidesPerView,
          // slidesPerView: 1,
          centeredSlides: false,
          spaceBetween: 5,
           freeMode: false,
          allowTouchMove:true,
           loop: false,
           breakpoints: {
            1024: {
              slidesPerView: 3,
            },
            600: {
              slidesPerView: 2,
            },
            480: {
              slidesPerView: 1,      
            }
          },
      navigation: {
        prevEl: '.custom-prev-icon',
        nextEl: '.custom-next-icon',
      },
    });
      }
    this.pathGroups?.forEach((_pathGroup: any, index: number) => {
      const swiperContainer = document.getElementById('swiperContainer_' + index);
  
      if (swiperContainer) {
        const swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: this.slidesPerView,
          // slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 5,
          freeMode: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop: false, // Disable looping here
          breakpoints: {
            1024: {
              slidesPerView: 3,
            },
            600: {
              slidesPerView: 2,
            },
            480: {
              slidesPerView: 1,      
            }
          },
        });
  
        swiperInstance.on('slideChange', () => {
          // You can add custom logic if needed
        });
  
        this.swiperInstances['swiperContainer_' + index] = swiperInstance;
      }
    });
    this.swiperInitialized = true;
  }
  scrollToNext(index: number): void {
    const swiperContainerId = 'swiperContainer_' + index
    const swiperContainer = document.getElementById(swiperContainerId)
    if (swiperContainer) {
    this.swiperInstances[swiperContainerId].slideTo(this.swiperInstances[swiperContainerId]?.activeIndex+ (+this.swiperInstances[swiperContainerId]?.params?.slidesPerView));
    }
  }
  
  scrollToPrev(index: number): void {
    const swiperContainerId = 'swiperContainer_' + index
    const swiperContainer = document.getElementById(swiperContainerId)
    if (swiperContainer) {
      this.swiperInstances[swiperContainerId].slideTo(this.swiperInstances[swiperContainerId]?.activeIndex- (+this.swiperInstances[swiperContainerId]?.params?.slidesPerView));
    }
  }


  selectGroupTab(tabKey: string) {
    this.selectedGroupTab = tabKey;
    this.appState.set('allPathsSelectedTab', tabKey);
    this.showMobileDropdown = false;
    Object.values(this.swiperInstances).forEach(swiper => swiper?.slideTo(0, 0));
    if (this.swiper) { this.swiper.slideTo(0, 0); }
  }

  get activeMobileLabel(): string {
    if (this.selectedGroupTab === 'all') return 'All Paths';
    if (this.selectedGroupTab === 'in_progress') return 'Paths in progress';
    return this.selectedGroupTab;
  }

  buildGroupTabs() {
    this.pathGroupTabs = (this.filteredPathsGroups || [])
      .map(g => g.groupName)
      .filter(name => !!name);

    const validTabs = new Set(['all', 'in_progress', ...this.pathGroupTabs]);
    if (!validTabs.has(this.selectedGroupTab)) {
      this.selectedGroupTab = 'all';
      this.appState.set('allPathsSelectedTab', 'all');
    }
  }

  expandCollapse(index) {
    this.isExpanded[index] = !this.isExpanded[index]
  }
  toggleDescription(path: any): void {
    this.expandedPaths[path.id] = !this.expandedPaths[path.id];
  }

  getTextContent(html: string): string {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.innerText || tempElement.textContent || '';
  }
  
}